import NextImage from '@allesauto/core/nextImage';
import { FieldTypeAsset } from '@allesauto/utils/consts';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';
import React, { FC } from 'react';

import QuickEntryWidget from '../QuickEntryWidget/QuickEntryWidget';
import { VehicleSearchFormProps } from '../QuickEntryWidget/VehicleSearchForm/VehicleSearchForm';

export type HeroStageWithWidgetProps = {
  hasWidget: boolean;
  headline: string;
  vehicleSearchForm?: VehicleSearchFormProps;
  imageDesktop: FieldTypeAsset;
  imageMobile: FieldTypeAsset;
  component: string;
  _uid: string;
  _editable?: string;
  selectedTabWidget?: number;
};

const HeroStageWithWidget: FC<
  React.PropsWithChildren<HeroStageWithWidgetProps>
> = (props) => {
  const {
    hasWidget = true,
    headline,
    vehicleSearchForm,
    imageDesktop,
    imageMobile,
    selectedTabWidget = 0,
  } = props;

  const className = {
    wrapper: clsx(
      'aspect-square bg-transparent grid grid-cols-24 grid-rows-1 w-full lg:aspect-[2/1] lg:relative'
    ),
    headlineWrapper:
      'lg:absolute md:mb-60px lg:bottom-1/4 lg:translate-y-1/4 font-headline col-end-24 col-start-2 lg:col-end-12 mb-40px lg:mb-0 self-end z-40 row-span-full text-green60 monochrome:text-black flex flex-col items-start',
    headlineFirst: 'text-title',
    headlineSecond: 'text-title',
    headlineThird: 'text-title',
    image:
      'col-span-full wl-header-margin-start-page row-span-full z-30 relative',
    visibleOnMobile: 'block lg:hidden',
    visibleOnDesktop: 'hidden lg:block',
  };

  const [firstHeadlineWord, ...remainingHeadlineWords] = headline.split(/\s+/);
  const thirdHeadlineWord = remainingHeadlineWords.pop();
  const secondHeadlineWord = remainingHeadlineWords.join(' ');

  return (
    <div {...sbEditable(props)} className="relative">
      <div className={className.wrapper}>
        <div className={className.headlineWrapper}>
          <span className={className.headlineFirst}>{firstHeadlineWord}</span>
          <span className={className.headlineSecond}>{secondHeadlineWord}</span>
          <span className={className.headlineThird}>{thirdHeadlineWord}</span>
        </div>
        <div className={className.image}>
          <NextImage
            useCustomLoader={false}
            alt={imageMobile.alt ?? ''}
            src={imageMobile.filename}
            layout="fill"
            objectFit="cover"
            objectPosition="20% center"
            quality={50}
            priority={true}
            className={className.visibleOnMobile}
          />
          <NextImage
            useCustomLoader={false}
            alt={imageDesktop.alt ?? ''}
            src={imageDesktop.filename}
            layout="fill"
            objectFit="cover"
            objectPosition="20% center"
            quality={75}
            priority={true}
            className={className.visibleOnDesktop}
          />
        </div>
      </div>
      <div className="home-quick-entry-widget z-30 lg:absolute lg:right-[4.166%]">
        {hasWidget && vehicleSearchForm && (
          <QuickEntryWidget
            vehicleSearchForm={vehicleSearchForm}
            defaultSelectedTabIndex={selectedTabWidget}
          />
        )}
      </div>
    </div>
  );
};

export default HeroStageWithWidget;
